import { useContext } from 'react'

import { AppContext } from './Wrapper'

function useAppState() {
  return useContext(AppContext)
}

export default useAppState
